import { BaseService } from "./base.service";

export class RegisterService extends BaseService {
  constructor() {
    super("/register");
  }

  async checkIfExists(payload: {
    mobile?: string;
    email?: string;
  }): Promise<boolean> {
    return this.post<boolean>("/check-existing", payload);
  }
}

export const registerService = new RegisterService();
